{
  "name": "external-window-pool",
  "version": "0.0.69",
  "scripts": {
    "ng": "ng",
    "start": "clear ; ng serve --watch --disable-host-check=true --ssl=true --host 0.0.0.0 --ssl-cert ./build/server.crt --ssl-key ./build/server.key",
    "build": "ng build",
    "post-build-route": "node ./build/post-build-route.js",
    "pre-build": "node ./build/updateVersionNumber.js",
    "post-build": "node ./build/post-build.js",
    "post-build-es5": "node ./build/post-build-es5.js",
    "post-build-es-2015": "node ./build/post-build-es2015.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@ngxmc/moment-adapter": "^19.2.2",
    "@angular/animations": "^19.2.4",
    "@angular/cdk": "^19.2.7",
    "@angular/common": "^19.2.4",
    "@angular/compiler": "^19.2.4",
    "@angular/core": "^19.2.4",
    "@angular/forms": "^19.2.4",
    "@angular/google-maps": "^19.0.1",
    "@angular/localize": "^19.2.4",
    "@angular/material": "^19.2.7",
    "@angular/material-moment-adapter": "^19.2.7",
    "@angular/platform-browser": "^19.2.4",
    "@angular/platform-browser-dynamic": "^19.2.4",
    "@angular/router": "^19.2.4",
    "@angular/service-worker": "^19.2.4",
    "@ngxmc/datetime-picker": "^19.3.1",
    "@primeng/themes": "^19.0.10",
    "@types/lodash": "^4.17.16",
    "bootstrap": "^5.2.3",
    "cldr-data": "^36.0.0",
    "color-blind": "^0.1.3",
    "crypto-ts": "^1.0.2",
    "google-libphonenumber": "^3.2.39",
    "i": "^0.3.7",
    "intl-tel-input": "^19.5.7",
    "libphonenumber-js": "^1.10.48",
    "lodash": "^4.17.21",
    "marked": "^9.1.6",
    "moment": "^2.24.0",
    "echarts": "^5.6.0",
    "ng2-file-upload": "^5.0.0",
    "ngx-bootstrap": "^19.0.2",
    "ngx-clipboard": "^16.0.0",
    "ngx-colors": "^3.6.0",
    "ngx-echarts": "^17.1.0",
    "ngx-intl-tel-input": "^17.0.0",
    "ngx-markdown": "^19.1.1",
    "ngx-mat-select-search": "^8.0.0",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.5",
    "@angular/cli": "^19.2.5",
    "@angular/compiler-cli": "^19.2.4",
    "@types/jasmine": "~5.1.0",
    "@types/jest": "^29.5.14",
    "@types/node": "^22.10.1",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.2"
  }
}
